import React from 'react';
import { Link } from 'react-router-dom';
import { FiFacebook, FiTwitter, FiInstagram } from 'react-icons/fi';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    legal: [
      { path: '/politique-confidentialite', label: 'Politique de confidentialité' },
      { path: '/cookies', label: 'Politique des cookies' },
      { path: '/conditions-utilisation', label: 'Conditions d\'utilisation' },
    ],
    resources: [
      { path: '/a-propos', label: 'À propos' },
      { path: '/faq', label: 'FAQ' },
      { path: '/comparaison', label: 'Comparaison' },
    ],
  };

  return (
    <footer className="bg-dark-surface border-t border-dark-border">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-xl font-bold text-white mb-4">PariClub FR</h3>
            <p className="text-dark-muted mb-4">
              Votre guide expert pour les meilleures offres de paris sportifs en France.
              Comparez, choisissez et profitez des meilleurs bonus disponibles.
            </p>
            <div className="flex space-x-4">
              <a
                href="#"
                className="text-dark-muted hover:text-accent-primary transition-colors"
                aria-label="Facebook"
              >
                <FiFacebook className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="text-dark-muted hover:text-accent-primary transition-colors"
                aria-label="Twitter"
              >
                <FiTwitter className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="text-dark-muted hover:text-accent-primary transition-colors"
                aria-label="Instagram"
              >
                <FiInstagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Legal Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Légal</h4>
            <ul className="space-y-2">
              {footerLinks.legal.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-dark-muted hover:text-accent-primary transition-colors text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Ressources</h4>
            <ul className="space-y-2">
              {footerLinks.resources.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-dark-muted hover:text-accent-primary transition-colors text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Regulatory Badges */}
        <div className="mt-8 pt-8 border-t border-dark-border">
          <div className="flex flex-wrap items-center justify-center gap-6">
            <a
              href="https://anj.fr/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:opacity-100 transition-opacity"
            >
              <img
                src="/images/footer/anj.webp"
                alt="ANJ"
                className="h-12 opacity-70 hover:opacity-100 transition-opacity"
                loading="lazy"
              />
            </a>
            <a
              href="https://www.hippodromesenfete.fr/jouons-responsable/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:opacity-100 transition-opacity"
            >
              <img
                src="/images/footer/jouns.webp"
                alt="JOUNS"
                className="h-12 opacity-70 hover:opacity-100 transition-opacity"
                loading="lazy"
              />
            </a>
            <a
              href="https://www.data.gouv.fr/en/organizations/autorite-de-regulation-des-jeux-en-ligne-arjel/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:opacity-100 transition-opacity"
            >
              <img
                src="/images/footer/ARJEL.webp"
                alt="ARJEL"
                className="h-12 opacity-70 hover:opacity-100 transition-opacity"
                loading="lazy"
              />
            </a>
            <a
              href="https://mediateurdesjeuxenligne.fr/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:opacity-100 transition-opacity"
            >
              <img
                src="/images/footer/mediateur.webp"
                alt="Médiateur"
                className="h-12 opacity-70 hover:opacity-100 transition-opacity"
                loading="lazy"
              />
            </a>
            <a
              href="https://www.gambleaware.org/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:opacity-100 transition-opacity"
            >
              <img
                src="/images/footer/gambleaware.webp"
                alt="Gamble Aware"
                className="h-12 opacity-70 hover:opacity-100 transition-opacity"
                loading="lazy"
              />
            </a>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 pt-8 border-t border-dark-border text-center">
          <p className="text-dark-muted text-sm">
            © {currentYear} PariClub FR. Tous droits réservés. | Jeu responsable 18+
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

